<style scoped>
.carousel-container {
  position: relative;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: center;
  margin: auto;
  margin-top: 4% !important;
  padding: 0 5px;
}
@media screen and (min-width: 835px) {
  #caroussel_top {
    display: block;
  }
  #caroussel_top-mobile {
    display: none;
  }
}
@media screen and (max-width: 834px) {
  #caroussel_top {
    display: none;
  }
  #caroussel_top-mobile {
    display: block;
  }
}
</style>

<template>
  <div class="carousel-container">
    <div
      id="caroussel_top"
      class="slide-carousel owl-carousel style-nav-1 caroussel_homepage"
      data-items="1"
      data-loop="1"
      data-sliderspeed="1500"
      data-paginationSpeed="500"
      data-nav="true"
      data-lazyload="true"
      data-dots="false"
      data-autoplay="true"
    >
      <div v-for="(banner, index) in sliders" :key="index" class="item-slide">
        <a
          :target="banner.Url.startsWith('http') ? '_blank' : '_self'"
          :href="banner.Url.startsWith('http') ? banner.Url : `${$SiteUrl}/loja/${banner.Tipo === 'Campanha' ? 'campanhas' : 'marcas'}/${banner.Url}`"
        >
          <img
            :src="$imageUrl + '/Content/img/' + banner.Tipo + '/' + banner.ID + '/aldo40/' + banner.Banner"
            :alt="banner.Alt"
            :title="banner.Title"
            class="img-slide"
          />
        </a>
      </div>
    </div>
    <div
      id="caroussel_top-mobile"
      class="slide-carousel owl-carousel style-nav-1 caroussel_homepage"
      data-items="1"
      data-loop="1"
      data-sliderspeed="1500"
      data-paginationSpeed="500"
      data-nav="true"
      data-lazyload="true"
      data-dots="false"
      data-autoplay="true"
    >
      <div v-for="(banner, index) in slidersMobile" :key="index" class="item-slide">
        <a
          :target="banner.Url.startsWith('http') ? '_blank' : '_self'"
          :href="banner.Url.startsWith('http') ? banner.Url : `${$SiteUrl}/loja/${banner.Tipo === 'Campanha' ? 'campanhas' : 'marcas'}/${banner.Url}`"
        >
          <img
            :src="$imageUrl + '/Content/img/' + banner.Tipo + '/' + banner.ID + '/aldo40/' + banner.Banner"
            :alt="banner.Alt"
            :title="banner.Title"
            class="img-slide"
          />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
      currentIndex: 0, // Slide atual
      sliders: [],
      slidersMobile: [],
    }
  },
  created: function () {
    try {
      const self = this

      axios
        .get(`${this.$apiUrl}Marketing.svc/gethomemarketing`)
        .then((response) => {
          if (response.data) {
            let respHomeRotativo = response.data.find((element) => element.Name == 'getCampanhaMarcaBannerHomeRotativo')
            // o homeRotativoTop é o que será usado no formato mobile
            let respHomeRotativoTop = response.data.find((element) => element.Name == 'getCampanhaMarcaBannerHomeTop')

            if (respHomeRotativo.JSON.length > 0) {
              self.sliders = respHomeRotativo.JSON
            }
            if (respHomeRotativoTop.JSON.length > 0) {
              self.slidersMobile = respHomeRotativoTop.JSON
            }
          }
        })
        .catch((e) => {})
    } catch (err) {
      console.log(err)
    }
  },
}
</script>
